// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"e9ee1087","239":"4a41bfb1","441":"201d1196","549":"4b041032","578":"1316f6a9","622":"909ece56","977":"2899dd08"}[chunkId] + ".chunk.js";
};